import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastService } from "@shared/services/toast/toast.service";
import { catchError, map, of } from "rxjs";
import { environment } from "src/environments/environment";
import { SubscriptionService } from "src/services/subscription.service";

const hasSalubiPlus = (productId: string | null, status: string): boolean =>
	productId === environment.SubscriptionPlusProductId &&
	(status === "Active" || status === "StopRequested");

export const requiresSalubiPlus: CanActivateFn = () => {
	const subscriptionService = inject(SubscriptionService);
	const router = inject(Router);
	const toastService = inject(ToastService);
	const translate = inject(TranslateService);

	// Entitlement can change during the current app session, so do not make an
	// access-control decision from a previously cached subscription response.
	subscriptionService.invalidateSubscriptionsCache();

	const deny = () => {
		toastService.warning(translate.instant("salubi_plus_required"));
		return router.createUrlTree(["/salubi-plus"]);
	};

	return subscriptionService.getUserSubscriptions().pipe(
		map((subscriptions) =>
			subscriptions.some((subscription) =>
				hasSalubiPlus(subscription.productId, subscription.status),
			)
				? true
				: deny(),
		),
		catchError(() => of(deny())),
	);
};
